module.exports = __webpack_public_path__ + "static/img/logo.81364dd5.png";